const loadingLabel = "Ielādē";
const lvLV = {
  loadingLabel
};
export {
  lvLV as default,
  loadingLabel
};
